var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReleaseNotesIcon = function SvgReleaseNotesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1---internal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-14",
    transform: "translate(-57.000000, -1190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 1142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(57.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.88126312,0.169254658 L18.9720497,0.169254658 C19.5243344,0.169254658 19.9720497,0.616969909 19.9720497,1.16925466 L19.9720497,22.1878882 C19.9720497,22.7401729 19.5243344,23.1878882 18.9720497,23.1878882 L1,23.1878882 C0.44771525,23.1878882 6.76353751e-17,22.7401729 0,22.1878882 L-5.55111512e-16,5.89975937 C-8.28647559e-16,5.62910393 0.109709453,5.37000744 0.304069627,5.1816501 L5.18533275,0.451145393 C5.3718875,0.27035241 5.6214771,0.169254658 5.88126312,0.169254658 Z",
    id: "Rectangle-3",
    fill: "#B2BBC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.4408921e-14,5.50113202 L3.22976157,5.50449969 C4.42269598,5.50574356 5.39076875,4.5396875 5.39201262,3.34675309 C5.3920134,3.34600234 5.3920138,3.3452516 5.3920138,3.34450086 L5.3920138,0.103329135",
    id: "Path-8",
    fill: "#6D8190"
  })))))));
};
export default SvgReleaseNotesIcon;